import {APIService} from "../../common/APIService";
import {Task, TaskStatus} from "../../dto/Task";

export class TaskService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: object[]}>(`tasks`);
    return json.data.map(item => Task.fromJson(item))
  }
  public async browseByProjectId(projectId: string) {
    const json = await this.getJson<{data: object[]}>(`projects/${projectId}/tasks`);
    return json.data.map(item => Task.fromJson(item))
  }

  public async addTask(projectId: string, description: string, type?: string, amount?: number, thickness?: number, note?: string, isImportant?: boolean) {
    const json = await this.postJson<{ data: object[] }>(`projects/${projectId}/tasks`, {
      task_name: description,
      ...(type !== undefined ? {quantity_type: type} : {}),
      ...(amount !== undefined ? {quantity_amount: amount} : {}),
      ...(thickness !== undefined ? {quantity_thickness: thickness} : {}),
      ...(note !== undefined ? {note: note} : {}),
      ...(isImportant !== undefined ? {is_workorder_remark_important: isImportant} : {})
    })
    return Task.fromJson(json.data)
  }

  public async addTasks(projectId: string, description: string[], type?: string, amount?: number, thickness?: number, note?: string, isImportant?: boolean) {
    const json = await this.postJson<{ data: object[] }>(`projects/${projectId}/tasks`, {
      task_name: description,
      ...(type !== undefined ? {quantity_type: type} : {}),
      ...(amount !== undefined ? {quantity_amount: amount} : {}),
      ...(thickness !== undefined ? {quantity_thickness: thickness} : {}),
      ...(note !== undefined ? {note: note} : {}),
      ...(isImportant !== undefined ? {is_workorder_remark_important: isImportant} : {})
    })
    return json.data.map(item => Task.fromJson(item))
  }

  public async updateTaskStatus(taskId: string, status: TaskStatus) {
    await this.postJson(`tasks/${taskId}`, {
      status: status,
    })
  }
}